<template>
  <div class="hang_up">
    <div class="hang_up_item">
      <a
        @click="
          $router.push({
            path: '/mall/cart',
          })
        "
        class="shop_cart"
      >
        <div class="count">{{ count }}</div>
        <img src="@/assets/images/opcitycats.png" alt />
        <div>购物车</div>
      </a>
    </div>
    <div class="hang_up_item">
      <a @click="homeClick">
        <img src="@/assets/images/home.png" alt />
        <div>首页</div>
      </a>
    </div>
    <div class="hang_up_item">
      <a @click="profileClick">
        <img src="@/assets/images/profile.png" alt />
        <div>个人中心</div>
      </a>
    </div>
  </div>
</template>

<script>
import { cartProducttNum } from '@/api/productsDetaile'
import getIsWx from '@/mixins/getIsWx'
import { FRONTEND_HOST } from '@/config/domainnameconstant'

export default {
  name: 'HangUpView',
  mixins: [getIsWx],
  data() {
    return {
      count: 0,
    }
  },
  created() {
    if (this.token) {
      this.shoppingCartsNum()
    }
  },
  methods: {
    // 查询购物车数量
    shoppingCartsNum() {
      cartProducttNum().then((res) => {
        // console.log('查询购物车', res.data.data)
        this.count = res.data.data
      })
    },
    getCount() {
      this.count++
    },
    homeClick() {
      this.$callApp('Android', 'GoHomePageMethod', '')
      this.$callApp('iOS', 'GoHomePageMethod', '')
      console.log('home')
    },
    profileClick() {
      this.$callApp('Android', 'GoPersonCenterMethod', '')
      this.$callApp('iOS', 'GoPersonCenterMethod', '')
      console.log('profile')
    },
  },
}
</script>

<style lang="less" scoped>
.hang_up {
  position: fixed;
  // top: 1200px;
  padding: 0px 5px 5px;
  bottom: 10px;
  height: 55px;
  width: 180px;
  border-radius: 20px;
  display: flex;
  opacity: 0.9;
  background: -webkit-gradient(linear, 0 0, 0 100%, from(white), to(#a9a9a9));
}
.hang_up_item {
  margin-top: 7.5px;
  flex: 1;
  text-align: center;
}
.hang_up_item div {
  padding-top: 5px;
  font-size: 9px;
  color: black;
}
.hang_up_item img {
  width: 25px;
  height: 25px;
}
.shop_cart {
  position: relative;
  .count {
    position: absolute;
    left: 15px;
    top: -12px;
    text-align: center;
    color: @cart-num-color;
    background: @cart-num-background;
    padding: 3.5px;
    font-size: 12px;
    border-radius: 50%;
  }
}
</style>
